<mat-form-field class="modern-select" [appearance]="appearance" [class.generic-select-plain]="plain" [class.generic-control-invalid]="ngControl && ngControl.invalid && ngControl.touched">
  <mat-label *ngIf="label">{{ label | localize }}</mat-label>
  <mat-select
    [value]="value"
    (selectionChange)="onSelectionChange($event)"
    [multiple]="multiple"
    [required]="required"
    [disabled]="disabled || loading"
    (openedChange)="onTouched()"
    (opened)="opened.emit()"
  >
    <mat-select-trigger *ngIf="triggerTemplate">
      <ng-container *ngTemplateOutlet="triggerTemplate; context: { $implicit: value }"></ng-container>
    </mat-select-trigger>

    <mat-option *ngIf="nullOption" [value]="null">{{ nullOptionLabel | localize }}</mat-option>

    <ng-container *ngIf="!loading && options?.length > 0">
      <mat-option *ngFor="let option of options" [value]="getOptionValue(option)" [disabled]="optionDisabled ? optionDisabled(option) : false">
        <ng-container *ngIf="optionTemplate; else defaultOptionText">
          <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option }"></ng-container>
        </ng-container>
        <ng-template #defaultOptionText>{{ getDisplayValue(option) }}</ng-template>
      </mat-option>
    </ng-container>

    <mat-option *ngIf="!loading && (!options || options.length === 0)" disabled>
      {{ emptyMessage | localize }}
    </mat-option>

    <mat-option *ngIf="loading" disabled>
      {{ 'LoadingWithThreeDot' | localize }}
    </mat-option>
  </mat-select>
  <mat-hint *ngIf="ngControl && ngControl.invalid && ngControl.touched" class="generic-control-error-hint">
    {{ getErrorMessages() }}
  </mat-hint>
</mat-form-field>
